import { render, staticRenderFns } from "./AllOrgDropTree.vue?vue&type=template&id=470f3645&"
import script from "./AllOrgDropTree.vue?vue&type=script&lang=js&"
export * from "./AllOrgDropTree.vue?vue&type=script&lang=js&"
import style0 from "./AllOrgDropTree.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports